import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";


export class FRVariable extends FRBase{
    public Name:string;
    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);
        this.Name=this.Options.d;
    }

    Parse(): any {
        return this.Retriever.GetVar(this.Name);
    }

    Assign(Value: FRBase) {
        this.Retriever.SetVar(this.Name,Value);
    }
}


FRFactory.AddField('VAR',FRVariable);